import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import axios from 'axios';
import Table from '../../components/Table';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';
import Link from 'react-router-dom/es/Link';

export default class GabaritoModal extends React.Component {
  state = {
    data: [],
    pageSize: this.defaultPageSize,
  };

  onOpened = () => {
    if (this.shouldFetchData) {
      this.shouldFetchData = false;
      this.fetchData();
    }
  };

  getPageSize(data) {
    if (data.length === 0) {
      return 1;
    }

    if (data.length < this.defaultPageSize) {
      return data.length;
    }

    return this.defaultPageSize;
  }

  shouldFetchData = true;
  defaultPageSize = 20;
  columns = [
    {
      Header: 'Posição',
      accessor: 'posicao',
    },
    {
      Header: 'Gabarito',
      accessor: 'gabarito',
    },
    {
      Header: 'Objeto de aprendizagem',
      accessor: 'item',
    },
    {
      Header: 'Objeto de aprendizagem no Exams	',
      accessor: 'id_exams',
    },
    {
      Header: 'Elaborador',
      accessor: 'criado_por',
    },
    {
      Header: 'Áreas do conhecimento',
      accessor: 'areas_conhecimento',
    },
    {
      Header: 'Dificuldade',
      accessor: 'dificuldade',
    },
    {
      Header: 'Eixo/Disciplina',
      accessor: 'disciplina',
    },
  ];

  fetchData() {
    this.setState({ fetchingData: true });
    const { avaliacao } = this.props;

    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${avaliacao}/gabarito`)
      .then((response) => {
        this.setState({
          data: response.data,
          fetchingData: false,
          pageSize: this.getPageSize(response.data),
        });
      });
  }

  renderBody = () => {
    const { data, fetchingData, pageSize } = this.state;

    if (fetchingData) {
      return <Loading />;
    }

    return (
      <Table
        columns={this.columns}
        data={data}
        pageSize={pageSize}
        onPageSizeChange={(pageSize) => this.setState({ pageSize })}
      />
    );
  };

  render() {
    const { toggle, isOpen, avaliacao } = this.props;

    return (
      <Modal
        filterable
        className="table-default"
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        centered
        onOpened={this.onOpened}
      >
        <ModalHeader toggle={toggle}>Objetos de aprendizagem</ModalHeader>
        <ModalBody className="bg-white pb-0">
          <div className="row">
            <div className="col-12 p-0">
              <div
                className="btn-group mt-2 mb-2 ml-3"
                role="group"
                aria-label="Actions"
              >
                <Link
                  className="btn btn-white"
                  to={`/instrumentos-cognitivos/gabarito/${avaliacao}/impressao`}
                >
                  <i className="fas fa-print" />
                </Link>
                <button className="btn btn-white">
                  <i className="far fa-file-excel" />
                </button>
              </div>
              {this.renderBody()}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="col-4 text-right">
            <button className="btn btn-white" onClick={toggle}>
              Fechar
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}
